import React, { memo } from 'react'

import { Footer } from '@frame/ui-components/footer'
import { LoadingSpinner } from '@frame/ui-components/loading-spinner'
import { Button } from '@frame/ui-primitives/button'

import { DataAttribute } from '@frame/types'

type Props = {
  hasFiles: boolean
  successFileCount: number
  isSubmitting: boolean
  isUploading: boolean
  onSubmit: () => void
  onUpload: () => void
  onNoPaystubs: () => void
}

export const DocumentsFooter = memo(function DocumentsFooter({
  hasFiles,
  successFileCount,
  isSubmitting,
  isUploading,
  onSubmit,
  onUpload,
  onNoPaystubs,
}: Props) {
  const primaryButton = hasFiles ? (
    <Button
      data-cy={DataAttribute.BTN_SUBMIT_FILES}
      disabled={successFileCount === 0 || isSubmitting}
      onClick={onSubmit}
      Icon={isSubmitting ? LoadingSpinner : undefined}
      applyCobranding
    >
      {successFileCount > 0 ? `Submit ${successFileCount} document${successFileCount > 1 ? 's' : ''}` : 'Submit'}
    </Button>
  ) : (
    <Button
      data-cy={DataAttribute.BTN_UPLOAD_FILES}
      disabled={isUploading || isSubmitting}
      onClick={onUpload}
      applyCobranding
    >
      Upload documents
    </Button>
  )

  const secondaryButton = hasFiles ? (
    <Button data-cy={DataAttribute.BTN_UPLOAD_FILES} intent="secondary" onClick={onUpload}>
      Upload more documents
    </Button>
  ) : (
    <Button data-cy={DataAttribute.BTN_MISSING_PAYSTUBS} intent="secondary" onClick={onNoPaystubs}>
      I can't find my paystubs
    </Button>
  )

  return (
    <Footer
      buttons={{
        primary: primaryButton,
        secondary: secondaryButton,
      }}
    />
  )
})
